/**
 * Genexa accessibility: Globo Mega Menu keyboard / ARIA enhancements.
 * Waits for ul.gm-menu (app-injected), then wires focus, blur, and Escape.
 *
 * Search drawer: keeps aria-expanded on .search-button in sync with #SearchDrawer
 * (toggle, Escape, close control, and outside-click all update aria-hidden only).
 */
(function () {
  'use strict';

  var ACTIVE_CLASS = 'gm-active';
  var SUBMENU_SEL = '.gm-submenu';
  var SEARCH_DRAWER_ID = 'SearchDrawer';
  var SEARCH_ARIA_BOUND = 'data-genexa-search-aria-bound';

  function closeSubmenu(li, anchor) {
    if (!li || !anchor) return;
    li.classList.remove(ACTIVE_CLASS);
    anchor.setAttribute('aria-expanded', 'false');
  }

  function openSubmenu(li, anchor) {
    if (!li || !anchor) return;
    li.classList.add(ACTIVE_CLASS);
    anchor.setAttribute('aria-expanded', 'true');
  }

  function submenuContainsFocus(li) {
    var sub = li.querySelector(SUBMENU_SEL);
    if (!sub || !document.activeElement) return false;
    return sub.contains(document.activeElement);
  }

  function bindTriggers(menuRoot) {
    var triggers = menuRoot.querySelectorAll('li.gm-item.gm-has-submenu > a.gm-target');
    triggers.forEach(function (anchor) {
      var li = anchor.closest('li.gm-item');
      if (!li) return;

      anchor.setAttribute('aria-haspopup', 'true');
      if (!anchor.hasAttribute('aria-expanded')) {
        anchor.setAttribute('aria-expanded', 'false');
      }

      if (anchor.dataset.genexaGmA11yBound === '1') return;
      anchor.dataset.genexaGmA11yBound = '1';

      anchor.addEventListener('focus', function () {
        openSubmenu(li, anchor);
      });

      anchor.addEventListener('blur', function () {
        window.requestAnimationFrame(function () {
          if (submenuContainsFocus(li)) return;
          closeSubmenu(li, anchor);
        });
      });

      var sub = li.querySelector(SUBMENU_SEL);
      if (sub) {
        sub.addEventListener('focusout', function () {
          window.requestAnimationFrame(function () {
            if (li.contains(document.activeElement)) return;
            closeSubmenu(li, anchor);
          });
        });
      }
    });
  }

  var escapeBound = false;

  function bindEscape() {
    if (escapeBound) return;
    escapeBound = true;

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      var active = document.activeElement;
      if (!active || !active.closest('ul.gm-menu')) return;

      var li = active.closest('li.gm-item.gm-has-submenu');
      while (li && !li.classList.contains(ACTIVE_CLASS)) {
        var parent = li.parentElement;
        li = parent ? parent.closest('li.gm-item.gm-has-submenu') : null;
      }
      if (!li || !li.classList.contains(ACTIVE_CLASS)) return;

      var trigger = li.querySelector(':scope > a.gm-target');
      if (!trigger) return;

      e.preventDefault();
      closeSubmenu(li, trigger);
      trigger.focus();
    });
  }

  function initMegaMenu(menuRoot) {
    bindTriggers(menuRoot);
    bindEscape();
  }

  function scanAndInit() {
    document.querySelectorAll('ul.gm-menu').forEach(function (menu) {
      if (menu.dataset.genexaGmA11yInit === '1') return;
      menu.dataset.genexaGmA11yInit = '1';
      initMegaMenu(menu);
    });
  }

  function removeEmptyProductLists() {
    document.querySelectorAll(
      '.product-single ul, .product-details__description ul, .product-details__collapsible-tab ul'
    ).forEach(function (list) {
      if (!list.querySelector('li') && !list.textContent.trim()) {
        list.remove();
      }
    });
  }

  function syncSearchButtonExpandedFromDrawer() {
    var drawer = document.getElementById(SEARCH_DRAWER_ID);
    if (!drawer) return;
    var open = drawer.getAttribute('aria-hidden') === 'false';
    document.querySelectorAll('.search-button').forEach(function (btn) {
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  function bindSearchDrawerAriaExpanded() {
    var drawer = document.getElementById(SEARCH_DRAWER_ID);
    if (!drawer || drawer.getAttribute(SEARCH_ARIA_BOUND) === '1') return;
    drawer.setAttribute(SEARCH_ARIA_BOUND, '1');
    syncSearchButtonExpandedFromDrawer();
    new MutationObserver(function () {
      syncSearchButtonExpandedFromDrawer();
    }).observe(drawer, { attributes: true, attributeFilter: ['aria-hidden'] });
  }

  function scanSearchDrawerAria() {
    bindSearchDrawerAriaExpanded();
  }

  function start() {
    scanAndInit();
    removeEmptyProductLists();
    scanSearchDrawerAria();
    var observer = new MutationObserver(function () {
      scanAndInit();
      removeEmptyProductLists();
      scanSearchDrawerAria();
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
